"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6784],{

/***/ 18779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ToggleIcon_ToggleIcon; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/ToggleIcon/assets/ChevronDown.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 4L5.78462 7.90382C5.81224 7.93418 5.8456 7.95838 5.88265 7.97492C5.91969 7.99147 5.95963 8 6 8C6.04037 8 6.08031 7.99147 6.11735 7.97492C6.1544 7.95838 6.18776 7.93418 6.21538 7.90382L10 4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var ChevronDown = (SvgChevronDown);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/ToggleIcon/assets/ChevronUp.svg
var ChevronUp_path;
function ChevronUp_extends() { ChevronUp_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ChevronUp_extends.apply(this, arguments); }

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/react.createElement("svg", ChevronUp_extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ChevronUp_path || (ChevronUp_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 8L5.78462 4.09618C5.81224 4.06582 5.8456 4.04162 5.88265 4.02508C5.91969 4.00853 5.95963 4 6 4C6.04037 4 6.08031 4.00853 6.11735 4.02508C6.1544 4.04162 6.18776 4.06582 6.21538 4.09618L10 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var ChevronUp = (SvgChevronUp);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/ToggleIcon/ToggleIcon.tsx




var ToggleIcon = function ToggleIcon(_ref) {
  var open = _ref.open;
  var Icon = open ? ChevronUp : ChevronDown;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {});
};

/* harmony default export */ var ToggleIcon_ToggleIcon = (ToggleIcon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/ToggleIcon/index.ts


/***/ }),

/***/ 76647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xN": function() { return /* reexport */ Navbar_Aside_Aside; },
  "H2": function() { return /* reexport */ Brand_Brand; },
  "VY": function() { return /* reexport */ Navbar_Content_Content; },
  "rU": function() { return /* reexport */ Navbar_Link_Link; },
  "ZP": function() { return /* reexport */ DesktopNavigation_Navbar_Navbar; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Navbar.views.ts


var Navbar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "e19vrw4c1"
} : 0)("position:relative;width:100%;padding:16px 32px;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19vrw4c0"
} : 0)("max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;align-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("xl");
}, "{justify-content:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Navbar.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseNavbar = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, _objectSpread(_objectSpread(_objectSpread({
    elevation: 2
  }, tokens), rest), {}, {
    ref: ref,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
      children: children
    })
  }));
});
var Navbar_Navbar = (0,useDesignTokens/* withDesignTokens */.Y)(BaseNavbar, function (_props, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_Navbar_Navbar = (Navbar_Navbar);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Brand/Brand.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1abf9211"
} : 0)("height:100%;display:flex;justify-content:start;align-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{flex:1;}" + ( true ? "" : 0));
var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1abf9210"
} : 0)( true ? {
  name: "1tjf9n0",
  styles: "height:100%;width:150px;text-decoration:none;display:inline-block"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Brand/Brand.tsx


var Brand_excluded = ["href", "children"];

function Brand_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Brand_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Brand_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Brand_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Brand = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? "/" : _ref$href,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Brand_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, Brand_objectSpread(Brand_objectSpread({}, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
      href: href,
      ref: ref,
      children: children
    })
  }));
});
/* harmony default export */ var Brand_Brand = (Brand);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Brand/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Content/Content.views.ts

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1j59zzq0"
} : 0)("display:flex;justify-content:space-between;gap:16px;align-items:center;height:100%;min-height:0;padding:0;list-style:none;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{gap:24px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Content/Content.tsx


var Content_excluded = ["children", "tokens"];

function Content_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Content_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Content_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Content_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseContent = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Content_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, Content_objectSpread(Content_objectSpread(Content_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Content_Content = (0,useDesignTokens/* withDesignTokens */.Y)(BaseContent, function () {
  return {};
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var Navbar_Content_Content = (Content_Content);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Content/index.ts

// EXTERNAL MODULE: ../../node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(27866);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/ToggleIcon/index.ts + 3 modules
var ToggleIcon = __webpack_require__(18779);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/theme.ts + 2 modules
var theme = __webpack_require__(15076);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Link/Link.views.ts


function Link_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Link_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19av9j42"
} : 0)( true ? "" : 0);
var Link_views_Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e19av9j41"
} : 0)("display:flex;justify-content:space-between;align-items:center;gap:6px;cursor:pointer;font-size:16px;font-weight:500;line-height:25px;font-family:", theme/* WHITNEY_FONT */.ef, ";color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";text-decoration:none;&:hover{color:", function (_ref2) {
  var hoverColor = _ref2.hoverColor;
  return hoverColor;
}, ";}&[aria-expanded='true']{color:", function (_ref3) {
  var openColor = _ref3.openColor;
  return openColor;
}, ";}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{font-size:18px;}" + ( true ? "" : 0));
var DropdownWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19av9j40"
} : 0)( true ? {
  name: "1qdkase",
  styles: "position:absolute;left:50%;transform:translateX(-50%);top:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Link/Link.tsx


var Link_excluded = ["children", "title", "href", "open", "tokens", "onClick", "onClickAway"];

function Link_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Link_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Link_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Link_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      title = _ref.title,
      href = _ref.href,
      open = _ref.open,
      tokens = _ref.tokens,
      onClick = _ref.onClick,
      onClickAway = _ref.onClickAway,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Link_excluded);

  var id = (0,react.useId)();
  var dropDownId = "dropdown-".concat(id);
  var wrapperRef = (0,react.useRef)(null);
  (0,useClickAway/* default */.Z)(wrapperRef, function () {
    if (open) {
      onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway();
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_views_Wrapper, {
    ref: wrapperRef,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_views_Link, Link_objectSpread(Link_objectSpread(Link_objectSpread(Link_objectSpread({}, href ? {
      as: "a",
      href: href
    } : {
      'aria-controls': dropDownId,
      'aria-expanded': open
    }), {}, {
      ref: ref,
      onClick: onClick
    }, tokens), rest), {}, {
      children: [title, typeof open === "boolean" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon/* default */.Z, {
        open: open
      })]
    })), open && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownWrapper, {
      id: dropDownId,
      children: children
    })]
  });
});
var Link_Link = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    openColor: theme.palette.twilio.blue[60],
    hoverColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      openColor: theme.palette.brand.segmentGreen[500],
      hoverColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      openColor: theme.palette.brand.segmentGreen[500],
      hoverColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var Navbar_Link_Link = (Link_Link);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Link/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Aside/Aside.views.ts

var Aside = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12odffs0"
} : 0)("display:flex;align-items:center;justify-content:end;gap:16px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{flex:1;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Aside/Aside.tsx


var Aside_excluded = ["children", "tokens"];

function Aside_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Aside_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Aside_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Aside_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseAside = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Aside_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aside, Aside_objectSpread(Aside_objectSpread(Aside_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Aside_Aside = (0,useDesignTokens/* withDesignTokens */.Y)(BaseAside, function () {
  return {};
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var Navbar_Aside_Aside = (Aside_Aside);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/Aside/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/index.ts






/***/ }),

/***/ 97182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ DesktopNavigation_Link_Link; },
  "xc": function() { return /* reexport */ LinkHighlighted_LinkHighlighted; },
  "aV": function() { return /* reexport */ DesktopNavigation_List_List; },
  "wp": function() { return /* reexport */ Navbar/* default */.ZP; },
  "pm": function() { return /* reexport */ DesktopNavigation_Subheading_Subheading; },
  "Ll": function() { return /* reexport */ DesktopNavigation_SupportLink_SupportLink; },
  "UK": function() { return /* reexport */ SupportMenu; },
  "T8": function() { return /* reexport */ UtilityNav_UtilityNav; },
  "ZP": function() { return /* reexport */ DesktopNavigation_DesktopNavigation; }
});

// UNUSED EXPORTS: Heading

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/DesktopNavigation.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var DesktopNavigation = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    ref: ref,
    children: children
  });
});

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("nav",  true ? {
  target: "e1p314cx0"
} : 0)( true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : 0);

/* harmony default export */ var DesktopNavigation_DesktopNavigation = (DesktopNavigation);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/UtilityNav/UtilityNav.views.ts


function UtilityNav_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1412qpe5"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var DescriptionSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1412qpe4"
} : 0)( true ? {
  name: "1auxtb1",
  styles: "display:inline-flex;justify-content:center"
} : 0);
var AsideSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1412qpe3"
} : 0)( true ? {
  name: "1r9eqj5",
  styles: "display:flex;gap:16px"
} : 0);
var CtaLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1412qpe2"
} : 0)("font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";margin:0 8px;padding:0;&:after{height:1px;bottom:-2px;}" + ( true ? "" : 0));
var UtilityNav_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1412qpe1"
} : 0)("width:100%;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:12px 32px;" + ( true ? "" : 0));
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1412qpe0"
} : 0)( true ? {
  name: "h1h4sr",
  styles: "max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;align-items:center"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _announcement$descrip;

  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var description = typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string" ? announcement.description : announcement === null || announcement === void 0 ? void 0 : (_announcement$descrip = announcement.description) === null || _announcement$descrip === void 0 ? void 0 : _announcement$descrip.md;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav_views_Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionSlot, {
        children: announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
            variant: "buttonSmall",
            children: description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaLink, {
            tokens: _objectSpread({}, tokens.buttonText),
            size: "small",
            href: announcement.ctaLink,
            hover: true,
            children: announcement.ctaTitle
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AsideSlot, {
        children: children
      })]
    })
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.brand.darkAcai[700],
      buttonText: {
        textColor: theme.palette.neutrals.white[100],
        hoverColor: theme.palette.brand.darkAcai[200]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.brand.darkAcai[700],
      buttonText: {
        textColor: theme.palette.neutrals.white[100],
        hoverColor: theme.palette.brand.darkAcai[200]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Heading/Heading.views.ts


var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "evah6rs0"
} : 0)("margin:0;font-weight:600;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Heading/Heading.tsx




var HeadingBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
    variant: "pLarge",
    color: tokens.color,
    ref: ref,
    children: children
  });
});
var Heading_Heading = (0,useDesignTokens/* withDesignTokens */.Y)(HeadingBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_Heading_Heading = ((/* unused pure expression or super */ null && (Heading_Heading)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Heading/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/List/List.views.ts


function List_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1gzlbhk0"
} : 0)( true ? {
  name: "9yyqsh",
  styles: "list-style-type:none;padding:24px 0;display:flex;gap:16px;flex-direction:column"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/List/List.tsx



var List_List = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
    ref: ref,
    children: children
  });
});
/* harmony default export */ var DesktopNavigation_List_List = (List_List);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/List/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Link/Link.views.ts


function Link_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bnxw0x3"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);
var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1bnxw0x2"
} : 0)("position:relative;margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";padding:2px 0;margin-right:8px;&::before{content:'';position:absolute;bottom:-2px;left:0;width:100%;height:1px;background-color:", function (_ref2) {
  var lineColor = _ref2.lineColor;
  return lineColor;
}, ";opacity:0;}&[aria-expanded='true']{color:", function (_ref3) {
  var openColor = _ref3.openColor;
  return openColor;
}, ";&+span{color:", function (_ref4) {
  var openColor = _ref4.openColor;
  return openColor;
}, ";}}" + ( true ? "" : 0));
var Link_views_Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1bnxw0x1"
} : 0)("line-height:1.5;display:inline-block;margin-top:4px;margin-bottom:0;color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.twilio.gray[60];
}, ";" + ( true ? "" : 0));
var Link_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1bnxw0x0"
} : 0)("display:inline-flex;gap:16px;text-align:left;text-decoration:none;cursor:pointer;&:hover{", Link, "{&::before{opacity:1;}}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Link/Link.tsx


var Link_excluded = ["title", "href", "description", "iconStart", "iconEnd", "onClick", "tokens"];

function Link_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Link_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Link_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Link_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      description = _ref.description,
      IconStart = _ref.iconStart,
      IconEnd = _ref.iconEnd,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Link_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_views_Wrapper, {
    href: href,
    as: href ? "a" : "button",
    onClick: onClick,
    children: [IconStart && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconStart, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, Link_objectSpread(Link_objectSpread(Link_objectSpread({
          variant: "pSmallBold",
          ref: ref
        }, tokens), rest), {}, {
          children: title
        })), IconEnd && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconEnd, {})]
      }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link_views_Description, {
        variant: "textRegularSmall",
        children: description
      })]
    })]
  });
});
var Link_Link = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    openColor: theme.palette.twilio.blue[60],
    lineColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900],
      openColor: theme.palette.brand.segmentGreen[500],
      lineColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900],
      openColor: theme.palette.brand.segmentGreen[500],
      lineColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_Link_Link = (Link_Link);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Link/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Subheading/Subheading.views.ts


var Subheading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e19j7nxu1"
} : 0)("margin:0;font-weight:600;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var Subheading_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19j7nxu0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Subheading/Subheading.tsx






var BaseSubheading = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Subheading_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subheading, {
      variant: "pSmall",
      ref: ref,
      color: tokens.color,
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
  });
});
var Subheading_Subheading = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubheading, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  }
});
/* harmony default export */ var DesktopNavigation_Subheading_Subheading = (Subheading_Subheading);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Subheading/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/LinkHighlighted/LinkHighlighted.views.ts


var LinkHighlighted_views_Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1qyhww82"
} : 0)("position:relative;margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";&::before{content:'';position:absolute;bottom:-2px;left:0;width:100%;height:1px;background-color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";}" + ( true ? "" : 0));
var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qyhww81"
} : 0)("color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";" + ( true ? "" : 0));
var LinkHighlighted_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1qyhww80"
} : 0)("display:inline-flex;gap:6px;text-align:left;text-decoration:none;cursor:pointer;&:hover{", Icon, "{color:", function (_ref4) {
  var hoverColor = _ref4.hoverColor;
  return hoverColor;
}, ";}", LinkHighlighted_views_Link, "{&::before{background-color:", function (_ref5) {
  var hoverColor = _ref5.hoverColor;
  return hoverColor;
}, ";}}}&:active{", Icon, "{color:", function (_ref6) {
  var activeColor = _ref6.activeColor;
  return activeColor;
}, ";}", LinkHighlighted_views_Link, "{color:", function (_ref7) {
  var activeColor = _ref7.activeColor;
  return activeColor;
}, ";&::before{background-color:", function (_ref8) {
  var activeColor = _ref8.activeColor;
  return activeColor;
}, ";}}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/LinkHighlighted/LinkHighlighted.tsx


var LinkHighlighted_excluded = ["title", "href", "iconEnd", "tokens"];

function LinkHighlighted_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function LinkHighlighted_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? LinkHighlighted_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LinkHighlighted_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseLinkHighlighted = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      IconEnd = _ref.iconEnd,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, LinkHighlighted_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkHighlighted_views_Wrapper, LinkHighlighted_objectSpread(LinkHighlighted_objectSpread({
    href: href
  }, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkHighlighted_views_Link, LinkHighlighted_objectSpread(LinkHighlighted_objectSpread(LinkHighlighted_objectSpread({
      variant: "pSmallBold",
      ref: ref
    }, tokens.link), rest), {}, {
      children: title
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, LinkHighlighted_objectSpread(LinkHighlighted_objectSpread({}, tokens.link), {}, {
      children: IconEnd && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconEnd, {
        size: "small"
      })
    }))]
  }));
});
var LinkHighlighted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLinkHighlighted, function (_props, theme) {
  return {
    link: {
      color: theme.palette.twilio.gray[100]
    },
    hoverColor: theme.palette.twilio.blue[60],
    activeColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var LinkHighlighted_LinkHighlighted = (LinkHighlighted);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/LinkHighlighted/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/index.ts + 14 modules
var Navbar = __webpack_require__(76647);
// EXTERNAL MODULE: ../../libs/matcha/components/MenuList/index.ts + 5 modules
var components_MenuList = __webpack_require__(28536);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/SupportMenu/SupportMenu.views.ts


var Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_MenuList/* default */.Z,  true ? {
  target: "ezrch1x1"
} : 0)("border-radius:0 0 5px 5px;padding:8px 0;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";border-top:1px solid ", function (_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor;
}, ";box-shadow:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows[2];
}, ";list-style-type:none;" + ( true ? "" : 0));
var Item = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(MenuList.Item,  true ? {
  target: "ezrch1x0"
} : 0)( true ? "" : 0)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/SupportMenu/SupportMenu.tsx


var SupportMenu_excluded = ["children", "tokens"];

function SupportMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SupportMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SupportMenu_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportMenu_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSupportLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SupportMenu_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, SupportMenu_objectSpread(SupportMenu_objectSpread(SupportMenu_objectSpread({
    role: "menu",
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var SupportLink = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSupportLink, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.brand.darkAcai[200]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.brand.darkAcai[200]
    };
  }
});
/* harmony default export */ var SupportMenu = (SupportLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/SupportMenu/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/SupportLink/SupportLink.views.ts


function SupportLink_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var SupportLink_views_Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1alctvu0"
} : 0)( true ? {
  name: "11t2w6r",
  styles: "padding:6px 20px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/SupportLink/SupportLink.tsx


var SupportLink_excluded = ["children", "href", "tokens"];

function SupportLink_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SupportLink_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SupportLink_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportLink_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var SupportLinkBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      href = _ref.href,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SupportLink_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupportLink_views_Item, SupportLink_objectSpread(SupportLink_objectSpread({
    ref: ref
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
      size: "small",
      variant: "mono",
      href: href,
      color: tokens.color,
      children: children
    })
  }));
});
var SupportLink_SupportLink = (0,useDesignTokens/* withDesignTokens */.Y)(SupportLinkBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_SupportLink_SupportLink = (SupportLink_SupportLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/SupportLink/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/index.ts












/***/ }),

/***/ 90429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ Brand_Brand; },
  "zx": function() { return /* reexport */ Button_Button; },
  "ZP": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Navbar.views.ts

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ek8d8jm0"
} : 0)("min-height:76px;display:grid;align-items:center;grid-auto-flow:column;justify-content:space-between;padding:20px;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Navbar.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseNavbar = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    ref: ref,
    children: children
  }));
});
var Navbar = (0,useDesignTokens/* withDesignTokens */.Y)(BaseNavbar, function (_props, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref2) {
    var _ref2$isMenuOpen = _ref2.isMenuOpen,
        isMenuOpen = _ref2$isMenuOpen === void 0 ? true : _ref2$isMenuOpen;

    if (isMenuOpen) {
      return {
        backgroundColor: theme.palette.neutrals.white[100]
      };
    }

    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var Navbar_Navbar = (Navbar);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Brand/Brand.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e94j0go0"
} : 0)( true ? {
  name: "xdpgg7",
  styles: "text-decoration:none;display:inline-block;width:150px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Brand/Brand.tsx


var Brand_excluded = ["href", "children"];

function Brand_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Brand_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Brand_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Brand_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Brand = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? "/" : _ref$href,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Brand_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, Brand_objectSpread(Brand_objectSpread({
    href: href
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
/* harmony default export */ var Brand_Brand = (Brand);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Brand/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Button/Button.views.ts


function Button_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MenuButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ertak0t0"
} : 0)( true ? {
  name: "1te1vur",
  styles: "position:relative;cursor:pointer"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Button/Button.tsx


var Button_excluded = ["onClick", "children"];

function Button_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Button_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Button_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Button_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Button = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Button_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, Button_objectSpread(Button_objectSpread({
    onClick: onClick
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
/* harmony default export */ var Button_Button = (Button);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/Button/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/index.ts




/***/ }),

/***/ 46452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": function() { return /* reexport */ Content_Content; },
  "$_": function() { return /* reexport */ Footer_Footer; },
  "X6": function() { return /* reexport */ MobileNavigation_Heading_Heading; },
  "v2": function() { return /* reexport */ MobileNavigation_Menu_Menu; },
  "LY": function() { return /* reexport */ NavItem_NavItem; },
  "$6": function() { return /* reexport */ List_NavList; },
  "wp": function() { return /* reexport */ Navbar/* default */.ZP; },
  "c2": function() { return /* reexport */ MobileNavigation_PrimaryLink_PrimaryLink; },
  "OE": function() { return /* reexport */ MobileNavigation_Tray_Tray; },
  "gt": function() { return /* reexport */ MobileNavigation_UtilityLink_UtilityLink; },
  "ZP": function() { return /* reexport */ MobileNavigation; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/MobileNavigation.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var MobileNav = function MobileNav(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: children
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("nav",  true ? {
  target: "e1oxa5i10"
} : 0)( true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : 0);

/* harmony default export */ var MobileNavigation = (MobileNav);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90429);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Menu/Menu.views.ts

var Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8p9yxq0"
} : 0)("position:fixed;top:0;left:0;z-index:999;width:100%;height:100%;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";display:grid;grid-auto-rows:max-content;width:100%;overflow-y:auto;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Menu/Menu.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Menu_Menu = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var MobileNavigation_Menu_Menu = (Menu_Menu);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Menu/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Footer/Footer.tsx


function Footer_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Footer = function Footer(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterWrapper, {
    children: children
  });
};

var FooterWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "egvkpjf0"
} : 0)( true ? {
  name: "2uxqqp",
  styles: "display:grid;gap:14px;padding:20px"
} : 0);

/* harmony default export */ var Footer_Footer = (Footer);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Footer/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Content/Content.tsx


function Content_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Content = function Content(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContent, {
    children: children
  });
};

var MenuContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euhvmxs0"
} : 0)( true ? {
  name: "hmxbog",
  styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px"
} : 0);

/* harmony default export */ var Content_Content = (Content);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Content/index.ts

// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/ToggleLinkContent/ToggleLinkContent.tsx


var ToggleLinkContent_excluded = ["children", "open"];

function ToggleLinkContent_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ToggleLinkContent_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ToggleLinkContent_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ToggleLinkContent_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var ToggleLinkContent = function ToggleLinkContent(_ref) {
  var children = _ref.children,
      open = _ref.open,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ToggleLinkContent_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", ToggleLinkContent_objectSpread(ToggleLinkContent_objectSpread({}, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
      initial: false,
      children: open && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
        initial: "collapsed",
        animate: "open",
        exit: "collapsed",
        variants: {
          open: {
            opacity: 1,
            height: "auto"
          },
          collapsed: {
            opacity: 0,
            height: 0
          }
        },
        transition: {
          duration: 0.2
        },
        children: children
      })
    })
  }));
};

/* harmony default export */ var ToggleLinkContent_ToggleLinkContent = (ToggleLinkContent);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/useToggleLink.ts


var useToggleLink = function useToggleLink(open) {
  var id = (0,react.useId)();
  var contentId = "content-".concat(id);
  var getTriggerProps = (0,react.useCallback)(function (_ref) {
    var href = _ref.href;
    return href ? {
      as: "a",
      href: href
    } : {
      'aria-expanded': open,
      'aria-controls': contentId
    };
  }, [open, contentId]);
  var getContentProps = (0,react.useCallback)(function () {
    return {
      id: contentId,
      'aria-hidden': !open
    };
  }, [contentId, open]);
  return {
    getTriggerProps: getTriggerProps,
    getContentProps: getContentProps
  };
};

/* harmony default export */ var MobileNavigation_useToggleLink = (useToggleLink);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/ToggleIcon/ToggleIcon.tsx



var ToggleIcon = function ToggleIcon(_ref) {
  var open = _ref.open;
  var Icon = open ? Common/* ChevronUpIcon */.g8 : Common/* ChevronDownIcon */.v4;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
    size: "small"
  });
};

/* harmony default export */ var ToggleIcon_ToggleIcon = (ToggleIcon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/ToggleIcon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/PrimaryLink/PrimaryLink.views.ts


function PrimaryLink_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var PrimaryLink_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elwkqbc1"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);
var PrimaryLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "elwkqbc0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonLarge;
}, ";width:100%;padding:14px 20px;display:flex;justify-content:space-between;align-items:center;text-decoration:none;border-bottom:1px solid ", function (_ref2) {
  var borderBottomColor = _ref2.borderBottomColor;
  return borderBottomColor;
}, ";color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";background-color:", function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, ";&[aria-expanded='true']{color:", function (_ref5) {
  var openColor = _ref5.openColor;
  return openColor;
}, ";background-color:", function (_ref6) {
  var openBackgroundColor = _ref6.openBackgroundColor;
  return openBackgroundColor;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/PrimaryLink/PrimaryLink.tsx


var PrimaryLink_excluded = ["title", "href", "onClick", "open", "children", "tokens"];

function PrimaryLink_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function PrimaryLink_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? PrimaryLink_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PrimaryLink_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BasePrimaryLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      onClick = _ref.onClick,
      open = _ref.open,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, PrimaryLink_excluded);

  var _useToggleLink = MobileNavigation_useToggleLink(open),
      getTriggerProps = _useToggleLink.getTriggerProps,
      getContentProps = _useToggleLink.getContentProps;

  var isDropdown = typeof open === "boolean";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryLink_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryLink, PrimaryLink_objectSpread(PrimaryLink_objectSpread(PrimaryLink_objectSpread(PrimaryLink_objectSpread({
      ref: ref,
      onClick: onClick
    }, getTriggerProps({
      href: href
    })), tokens), rest), {}, {
      children: [title, isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon_ToggleIcon, {
        open: open
      })]
    })), isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleLinkContent_ToggleLinkContent, PrimaryLink_objectSpread(PrimaryLink_objectSpread({}, getContentProps()), {}, {
      open: open,
      children: children
    }))]
  });
});
var PrimaryLink_PrimaryLink = (0,useDesignTokens/* withDesignTokens */.Y)(BasePrimaryLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    backgroundColor: theme.palette.neutrals.white[100],
    borderBottomColor: theme.palette.twilio.gray[20],
    openColor: theme.palette.twilio.blue[60],
    openBackgroundColor: theme.palette.twilio.gray[10]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var MobileNavigation_PrimaryLink_PrimaryLink = (PrimaryLink_PrimaryLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/PrimaryLink/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/UtilityLink/UtilityLink.views.ts


function UtilityLink_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var UtilityLink_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehe56yu2"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);
var padding = {
  x: 20,
  y: 8
};
var Hightlight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ehe56yu1"
} : 0)("position:absolute;bottom:", padding.y / 2, "px;left:", padding.x, "px;right:", padding.x, "px;width:calc(100% - ", padding.x * 2, "px);height:1px;background-color:transparent;" + ( true ? "" : 0));
var UtilityLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ehe56yu0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall.css;
}, ";position:relative;width:100%;padding:", padding.y, "px ", padding.x, "px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid transparent;text-decoration:none;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";&[aria-expanded='true']{color:", function (_ref4) {
  var openColor = _ref4.openColor;
  return openColor;
}, ";", Hightlight, "{background-color:", function (_ref5) {
  var openBorderBottomColor = _ref5.openBorderBottomColor;
  return openBorderBottomColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/UtilityLink/UtilityLink.tsx


var UtilityLink_excluded = ["title", "open", "onClick", "href", "children", "tokens"];

function UtilityLink_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function UtilityLink_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? UtilityLink_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UtilityLink_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BaseUtilityLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      open = _ref.open,
      onClick = _ref.onClick,
      href = _ref.href,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, UtilityLink_excluded);

  var _useToggleLink = MobileNavigation_useToggleLink(open),
      getTriggerProps = _useToggleLink.getTriggerProps,
      getContentProps = _useToggleLink.getContentProps;

  var isDropdown = typeof open === "boolean";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UtilityLink_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UtilityLink, UtilityLink_objectSpread(UtilityLink_objectSpread(UtilityLink_objectSpread(UtilityLink_objectSpread({
      ref: ref,
      onClick: onClick
    }, getTriggerProps({
      href: href
    })), tokens), rest), {}, {
      children: [title, isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon_ToggleIcon, {
        open: open
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hightlight, {})]
    })), isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleLinkContent_ToggleLinkContent, UtilityLink_objectSpread(UtilityLink_objectSpread({}, getContentProps()), {}, {
      open: open,
      children: children
    }))]
  });
});
var UtilityLink_UtilityLink = (0,useDesignTokens/* withDesignTokens */.Y)(BaseUtilityLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    backgroundColor: theme.palette.neutrals.white[100],
    openColor: theme.palette.twilio.blue[60],
    openBorderBottomColor: theme.palette.twilio.gray[20]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var MobileNavigation_UtilityLink_UtilityLink = (UtilityLink_UtilityLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/UtilityLink/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Tray/Tray.views.ts

var Tray = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1l725l0"
} : 0)("display:flex;flex-direction:column;padding:12px 0 24px 0;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";background:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";width:100%;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Tray/Tray.tsx


function Tray_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Tray_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Tray_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tray_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var TrayBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tray, Tray_objectSpread(Tray_objectSpread({
    ref: ref
  }, tokens), {}, {
    children: children
  }));
});
var Tray_Tray = (0,useDesignTokens/* withDesignTokens */.Y)(TrayBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
/* harmony default export */ var MobileNavigation_Tray_Tray = (Tray_Tray);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Tray/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/List/NavList.views.ts


function NavList_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1hiq1c00"
} : 0)( true ? {
  name: "1oco99j",
  styles: "list-style-type:none;padding:16px 0;display:flex;gap:16px;flex-direction:column"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/List/NavList.tsx



var NavList = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
    ref: ref,
    children: children
  });
});
/* harmony default export */ var List_NavList = (NavList);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/List/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Heading/Heading.views.ts


function Heading_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1qrpbth2"
} : 0)("margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var Heading_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qrpbth1"
} : 0)( true ? {
  name: "ybax9c",
  styles: "padding:32px 36px 0 36px"
} : 0);
var Inner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qrpbth0"
} : 0)( true ? {
  name: "1i1kavw",
  styles: "display:flex;margin-bottom:6px;align-items:center;gap:12px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Heading/Heading.tsx






var HeadingBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var Icon = _ref.icon,
      children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Heading_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
      children: [Icon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h5",
        ref: ref,
        color: tokens.color,
        children: children
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
  });
});
var Heading_Heading = (0,useDesignTokens/* withDesignTokens */.Y)(HeadingBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var MobileNavigation_Heading_Heading = (Heading_Heading);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Heading/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/NavItem/NavItem.views.ts


function NavItem_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var NavItem_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "enknh5t2"
} : 0)( true ? {
  name: "sau5os",
  styles: "gap:4px;padding:0 36px;display:flex;flex-direction:column;text-decoration:none"
} : 0);
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enknh5t1"
} : 0)("margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enknh5t0"
} : 0)("margin:2px 0 0;line-height:1.5;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/NavItem/NavItem.tsx


var NavItem_excluded = ["href", "title", "description", "tokens"];

function NavItem_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function NavItem_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? NavItem_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavItem_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var NavItemBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var href = _ref.href,
      title = _ref.title,
      description = _ref.description,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, NavItem_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavItem_views_Wrapper, NavItem_objectSpread(NavItem_objectSpread({
    href: href
  }, rest), {}, {
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, NavItem_objectSpread(NavItem_objectSpread({
      variant: "buttonSmall"
    }, tokens.title), {}, {
      children: title
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, NavItem_objectSpread(NavItem_objectSpread({
      variant: "textRegularSmall"
    }, tokens.description), {}, {
      children: description
    }))]
  }));
});
var NavItem = (0,useDesignTokens/* withDesignTokens */.Y)(NavItemBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      title: {
        color: theme.palette.twilio.gray[100]
      },
      description: {
        color: theme.palette.twilio.gray[60]
      }
    };
  },
  light: function light(theme) {
    return {
      title: {
        color: theme.palette.brand.darkAcai[900]
      },
      description: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  },
  dark: function dark(theme) {
    return {
      title: {
        color: theme.palette.brand.darkAcai[900]
      },
      description: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  }
});
/* harmony default export */ var NavItem_NavItem = (NavItem);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/NavItem/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/index.ts













/***/ })

}]);